import { IntlProvider as ReactIntlProvider } from 'react-intl';
import { useContext, type ReactNode } from 'react';
import { ConfigurationContext } from '@printdeal/configuration/react';
import type { Locale } from '../types/gatsby';
import type { Messages } from '../hooks/useTranslations';

type IntlProviderProps = {
  children: ReactNode;
  localeFromPage?: Locale;
  messages: Messages;
};

const customFormats = {
  number: {
    noGroupingFormat: {
      useGrouping: false,
    },
  },
};

const IntlProvider = ({
  children,
  localeFromPage,
  messages,
}: IntlProviderProps) => {
  const { defaultLocale } = useContext(ConfigurationContext);
  const locale = localeFromPage || defaultLocale;

  return (
    <ReactIntlProvider
      key={locale} // See https://github.com/formatjs/react-intl/blob/master/docs/Components.md#dynamic-language-selection
      locale={locale}
      defaultLocale={defaultLocale}
      messages={messages}
      formats={customFormats}
    >
      {children}
    </ReactIntlProvider>
  );
};

export default IntlProvider;
